import React from 'react';
import { FinalFormField } from 'components';
import { useForm } from 'react-final-form-hooks';
import validator, { isRequired, isRegexValid } from 'lib/utils/validator';

const passwordValidator = /(?=^.{8,}$)(?=.*\d)(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/;

export default ({ onSubmit }) => {
  const { form, handleSubmit } = useForm({
    onSubmit,
    validate: (data) => validator(data, {
      password: [
        isRequired(),
        isRegexValid(
          passwordValidator,
          'Passwords must be at least eight characters in length, contain at least one lowercase letter, one uppercase letter, and one number.',
        )],
    }),
  });

  return (
    <form onSubmit={handleSubmit}>
      <div className="h4 b">Reset Password</div>
      <FinalFormField className="mt-1" form={form} autoFocus label="Password" name="password" type="password" />
      <button type="submit" className="btn-yellow fullwidth mt-2">Submit</button>
    </form>
  );
};
